module.exports = __webpack_public_path__ + "img/2.2.cd0d2079.png";